import { useEffect, useState } from 'react';
import { updateTicketList } from '@features/tickets/models/page';
import { theme } from '@unicorn/bms-theme';
import { ChildBase, SDUI } from '@unicorn/sdui';
import { baseSduiConfig } from '../../models/detail-sdui';
import { invocesJson } from './json';
import * as Styled from './styled';

const ticketsInvocesSdui = new SDUI('ticketsInvoces');

export const DetailInvocesSdui = ({ openedId }: { openedId: string | number | null }) => {
  const [sduiData, setSduiData] = useState([] as ChildBase[]);
  const [saveStatus, setSaveStatus] = useState<string | null>(null);

  const nowSaveStatus =
    (sduiData.find(({ token }) => token === 'to-save')?.data?.customData
      ?.saveStatus as string) ?? null;

  useEffect(() => {
    if (saveStatus === 'valid' && nowSaveStatus === null) {
      updateTicketList();
    }

    setSaveStatus(nowSaveStatus);
  }, [nowSaveStatus]);

  useEffect(() => {
    if (!openedId) return;

    ticketsInvocesSdui.setSduiConfig({
      ...baseSduiConfig,
      custom: { ...baseSduiConfig.custom, ticketId: openedId },
      setSduiData,
      log: false,
    });

    ticketsInvocesSdui.setSduiSource({
      source: invocesJson,
    });

    return () => {
      ticketsInvocesSdui.reset();
    };
  }, []);

  return (
    <Styled.Container>
      <ticketsInvocesSdui.SduiOutput componentsType="material-ui" theme={theme} />
    </Styled.Container>
  );
};
